import { render, staticRenderFns } from "./user-manage.vue?vue&type=template&id=b33e55d6&scoped=true"
import script from "./user-manage.vue?vue&type=script&lang=js"
export * from "./user-manage.vue?vue&type=script&lang=js"
import style0 from "./user-manage.vue?vue&type=style&index=0&id=b33e55d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33e55d6",
  null
  
)

export default component.exports